module.exports = __webpack_public_path__ + "static/0022-8cc4ed03812a49f026a1495c80af7125.png";